import React, {Component} from 'react'
import './App.css'
import adobeUrl from "./img/adobe.svg";
import hsbcUrl from "./img/hsbc.svg";
import visaUrl from "./img/visa.svg";

export default class App extends Component {
  
    render() {
      return (<div className="AppMain">
        <div className="AppBackground AppBackground0"></div>
        <div className="AppBackground AppBackground1"></div>
        <div className="AppBackground AppBackground2"></div>
        <div className="AppBlack"></div>
        <div className="AppContent">
          <h1 className="AppTitle">
            IR1
          </h1>
          <div className="AppTagLine">
            Software design & development consultancy<br></br>
            London
          </div>
          <div className="AppSection">
            Our Clients
          </div>
          <img className="AppClient" alt="HSBC" src={hsbcUrl}></img>
          <img className="AppClient" alt="Visa" src={visaUrl}></img>
          <img className="AppClient" alt="Adobe" src={adobeUrl}></img>
          <img className="AppClient" alt="Ren Skincare" src={require('./img/ren.png')}></img>
          <img className="AppClient" alt="We Heart Digital" src={require('./img/whd.png')}></img>
          <div className="AppSection">
            Contact
          </div>
          <div className="AppText">
            Contact us at: <a href="mailto:info@ir1.co">info@ir1.co</a>
          </div>
          <div className="AppFooter">
            IR1 is a trading name of ICR1 LTD<br></br>
            UK company number 10316649
          </div>
        </div>
      </div>)
    }
  
  }
  